export default __webpack_public_path__ + "static/media/unfold_more_black_24dp.ab70068e.svg";